import { addDays, differenceInCalendarDays, min, startOfDay, subDays } from "date-fns";

export type ViewsRange = "7d" | "30d" | "allTime";

export const viewsRanges: ViewsRange[] = ["7d", "30d", "allTime"];

export const viewsRangeLabels: Record<ViewsRange, string> = {
  "7d": "7 days",
  "30d": "30 days",
  allTime: "All time",
};

export interface DailyViews {
  date: Date;
  views: number;
}

export const getViewsRangeStart = (range: ViewsRange, viewedAt: string[], today: Date): Date => {
  const todayStart = startOfDay(today);

  switch (range) {
    case "7d":
      return subDays(todayStart, 6);
    case "30d":
      return subDays(todayStart, 29);
    case "allTime":
      return startOfDay(min([today, ...viewedAt.map((timestamp) => new Date(timestamp))]));
  }
};

export const groupViewsByDay = (viewedAt: string[], from: Date, to: Date): DailyViews[] => {
  const fromDay = startOfDay(from);
  const daysCount = differenceInCalendarDays(startOfDay(to), fromDay) + 1;

  if (daysCount <= 0) {
    return [];
  }

  const viewsByDay = new Map<number, number>();
  viewedAt.forEach((timestamp) => {
    const day = startOfDay(new Date(timestamp)).getTime();
    viewsByDay.set(day, (viewsByDay.get(day) ?? 0) + 1);
  });

  return Array.from({ length: daysCount }, (_, index) => {
    const date = addDays(fromDay, index);
    return { date, views: viewsByDay.get(date.getTime()) ?? 0 };
  });
};
